import { Injectable } from '@angular/core';
import { Subject, forkJoin, lastValueFrom, takeWhile } from 'rxjs';
import { PartnerDataModel } from 'src/app/account/models/accountModel';
import { AccountService } from 'src/app/account/services/account.service';
import { BaseService } from 'src/app/base.service';
import { AlertBtnText, AlertTitles, AlertTypes, APIUrls, AppSide, AppsListParams, AppStatesTexts, errorMsgsPopup, MNGUrls, SpotlightAppsCustomOrder, StorageKeyNamesCommon } from 'src/app/constants';
import { AppDataModel, CustomerEnabledUsersDataModel, CustomerEnabledUsersForPartnerDataModel } from '../models/storeModel';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/alert/services/alert.service';
import { CreateAppDataModel } from 'src/app/management/models/managementModel';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SharedService } from 'src/app/shared/shared.service';
import { Router } from '@angular/router';
import { SharedDataService } from 'src/app/shared/shared-data.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { AppsDataListParams } from 'src/app/shared/models/sharedModel';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  // spotlightApps = new Subject();

  // allApps = new Subject();

  // enabledApps = new Subject();

  // availApps = new Subject();

  getDifferentAppListsDataSub = new Subject();

  // appDetailsSubject = new Subject();

  customerUsersAndConfigDataSub = new Subject();

  customerConfigDataSub = new Subject();

  customerUsersAndConfigForPartnerDataSub = new Subject();

  customerConfigForPartnerDataSub = new Subject();

  destroySubscription = false;

  imagePath: any;

  tiersArrDomainDataSub = new Subject();

  tiersArrDataSub = new Subject();

  updateUsersDataSub = new Subject();

  updateUsersAtWebhooksDefUpdateDataSub = new Subject();

  disableUsersAtWebhooksDefUpdateDataSub = new Subject();

  updateDomainsDataSub = new Subject();

  updateDomainsAtWebhooksDefUpdateDataSub = new Subject();

  disableDomainsAtWebhooksDefUpdateDataSub = new Subject();

  requestAccessForAppDataSub = new Subject();

  requestAccessForAppDataSubA = new Subject();

  appInitDataSub = new Subject();

  customizeAppDataSub = new Subject();

  //  appCustomizeAppDocsDataSub = new Subject();

  customizeAppImageUrlsDataSub = new Subject();

  uploadImgDataSub = new Subject();

  viewOriginalAppDataSub = new Subject();

  appStatesTexts = AppStatesTexts;

  app_types = [];

  revokeStateDataSub = new Subject();

  revokeStateDataSubOM = new Subject();

  fetchCarouselData = new Subject();

  appsDataListParams: AppsDataListParams = {
    page: AppsListParams.page,
    perPage: AppsListParams.per_page_50,
    searchTerm: '',
    appType: ''
  }

  constructor(private baseService: BaseService, private alertService: AlertService,
    private accountService: AccountService, private spinner: NgxSpinnerService,
    private sharedService: SharedService, private router: Router, private sharedDataService: SharedDataService,
    private storageService: StorageService) {
  }

  getCustomizeAppInitializeData() {
    return {
      app_icon: '',
      app_icon_url: '',
      app_icon_file: '',
      app_icon_upload_url: '',
      app_image: '',
      app_image_url: '',
      app_image_file: '',
      app_image_upload_url: '',
      app_name: '',
      app_id: '',
      app_secret: '',
      description: '',
      short_description: '',
      vendor_app_fqdn: '',
      app_type: '',
      auth_type: '',
      app_status: '',
      geospec: [],
      user_tiers_enabled: false,
      user_mgmt_enabled: false,
      domain_mgmt_enabled: false,
      domain_tiers_enabled: false,
      tiersArr: [],
      tiersArrDomain: [],
      promoted_app: false,
      technicalFiles: [],
      technicalFilesToDelete: []
    };
  }

  getSelectedCategory(event: any) {
    return event === 'ALL' ? '' : event;
  }

  getSearchText(event: any) {
    if (event) {
      return event;
    } else {
      return '';
    }
  }

  // setSpotlightAppsOrder(dataMain: any) {
  //   const customOrder = SpotlightAppsCustomOrder;

  //   const orderMap: any = {};
  //   customOrder.forEach((app_name, index) => {
  //     orderMap[app_name] = index;
  //   });
  //   // console.log('orderMap', orderMap);

  //   const defaultValue = Infinity;

  //   dataMain.sort((a: any, b: any) => {
  //     const aOrder = orderMap[a.app_name] !== undefined ? orderMap[a.app_name] : defaultValue;
  //     const bOrder = orderMap[b.app_name] !== undefined ? orderMap[b.app_name] : defaultValue;

  //     // If both have a custom order, sort by that order
  //     if (aOrder !== defaultValue || bOrder !== defaultValue) {
  //       return aOrder - bOrder;
  //     }

  //     // If both are not in the custom order, sort alphabetically
  //     return a.app_name.localeCompare(b.app_name);
  //   });
  //   // console.log('dataMain', dataMain);
  //   return dataMain;
  // }

  filterSearchOperate(selectedCategory: string, searchText: string) {
    let filterString = '';
    const tempArr = [];
    if (selectedCategory) {
      tempArr.push({ param: 'app-types', value: selectedCategory })
    }
    if (searchText) {
      tempArr.push({ param: 'app-name', value: searchText })
    }
    if (tempArr.length) {
      tempArr.forEach((query: any, index) => {
        filterString = filterString + (index === 0 ? '?' : '&') + query.param + '=' + query.value;
        // console.log(index, filterString);
      });
    }
    // console.log(filterString);
    return filterString;
  }

  handleAppDataListParams(params: any) {
    let stirng = '';
    const tempArr = [];
    if (params && Object.keys(params).length) {
      for (const [key, value] of Object.entries(params)) {
        // console.log(`${key}: ${value}`);
        if (`${value}`) {

          tempArr.push({ param: this.getKeyValue(`${key}`), value: `${value}` })
        }
      }

      if (tempArr.length) {
        tempArr.forEach((query: any, index) => {
          stirng = stirng + (index === 0 ? '' : '&') + query.param + '=' + query.value;
          // console.log(index, filterString);
        });
      }
    }
    return stirng;
  }

  getKeyValue(key: string) {
    if (key === 'perPage') return 'per-page';
    if (key === 'searchTerm') return 'search-term';
    if (key === 'appType') return 'app-type';
    return key
  }

  getDifferentAppLists(isCustomerUser: boolean, partner_id: any, customer_name: any,
    isSpotlightApps: boolean, spotlightAppsParams: AppsDataListParams | null,
    isEnabledApps: boolean, enabledAppsParams: AppsDataListParams | null,
    isAvailableApps: boolean, availableAppsParams: AppsDataListParams | null,
    isAllApps: boolean, allAppsParams: AppsDataListParams | null, filterString?: string) {
    this.spinner.show();
    let getDifferentAppsBaseApiUrl = APIUrls.partnerApps + partner_id;

    let enabledAppApiURL = '';
    if (isCustomerUser) {
      enabledAppApiURL = getDifferentAppsBaseApiUrl + '/customer/' + customer_name + '/apps' + (filterString ? (filterString + '&fetch-images=true') : '?fetch-images=true');
    } else {
      enabledAppApiURL = getDifferentAppsBaseApiUrl + '/apps' + (filterString ? (filterString + '&enabled=true') : '?enabled=true');
    }

    let availableAppApiURL = '';
    if (isCustomerUser) {
      availableAppApiURL = getDifferentAppsBaseApiUrl + '/customer/' + customer_name + '/available-apps' + (filterString ? (filterString + '&fetch-images=true&exclude-revoked=true') : '?fetch-images=true&exclude-revoked=true');
    } else {
      availableAppApiURL = getDifferentAppsBaseApiUrl + '/apps' + (filterString ? (filterString + '&enabled=false') : '?enabled=false');
    }

    const allAppsParamsString = this.handleAppDataListParams(allAppsParams);
    // console.log('allAppsParamsString', allAppsParamsString);

    const tempObj: any = {};

    // const forkJoinArr = [];
    const getSpotlightApps = this.getRequest(MNGUrls.listApps + '?promoted=true&page=1&per-page=8' + (isCustomerUser && partner_id ? ('&partner-id=' + partner_id) : ''));
    const getEnabledApps = this.getRequest(enabledAppApiURL); // add next line when enabled apps data will have server side pagination: '&page=' + enabledAppsPage + '&per-page=' + enabledAppsPerPage;
    const getAvailApps = this.getRequest(availableAppApiURL); // add next line when available apps data will have server side pagination: '&page=' + availableAppsPage + '&per-page=' + availableAppsPerPage;
    const getAllApps = this.getRequest(MNGUrls.listApps + '?' + allAppsParamsString);

    if (isSpotlightApps) {
      // forkJoinArr.push(getSpotlightApps)
      tempObj.spotlightApps = getSpotlightApps;
    }

    if (isEnabledApps) {
      // forkJoinArr.push(getEnabledApps)
      tempObj.enabledApps = getEnabledApps;
    }

    if (isAvailableApps) {
      // forkJoinArr.push(getAvailApps)
      tempObj.availApps = getAvailApps;
    }

    if (isAllApps) {
      // forkJoinArr.push(getAllApps)
      tempObj.allApps = getAllApps;
    }

    forkJoin(tempObj)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
        this.spinner.hide();
        if (forkResponse && Object.keys(forkResponse).length) {
          this.getDifferentAppListsDataSub.next(forkResponse);
        }
      }, (error) => {
        this.spinner.hide();
      });
  }

  // getSpotlightApps(isCustomerUser?: boolean, partner_id?: any) {
  //   this.getRequest(MNGUrls.listApps + '?promoted=true' + (isCustomerUser && partner_id ? ('&partner-id=' + partner_id) : ''))
  //     .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
  //       next: (response: any) => {
  //         if (response && response.status === 200) {
  //           this.spotlightApps.next(response.body);
  //         }
  //       }
  //     });
  // }

  // getAllApps() {
  //   this.getRequest(MNGUrls.listApps)
  //     .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
  //       next: (response: any) => {
  //         if (response && response.status === 200) {
  //           this.allApps.next(response.body);
  //         }
  //       }
  //     });
  // }

  // getEnabledApps(isCustomerUser: boolean, partner_id: any, customer_name: any) {
  //   let finalURL = '';
  //   let xyz = APIUrls.partnerApps + partner_id;
  //   if (isCustomerUser) {
  //     finalURL = xyz + '/customer/' + customer_name + '/apps?fetch-images=true';
  //   } else {
  //     finalURL = xyz + '/apps?enabled=true';
  //   }
  //   this.getRequest(finalURL)
  //     .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
  //       next: (response: any) => {
  //         if (response && response.status === 200) {
  //           this.enabledApps.next(response.body);
  //         }
  //       }
  //     });
  // }

  // getAvailApps(isCustomerUser: boolean, partner_id: any, customer_name: any) {
  //   let finalURL = APIUrls.partnerApps + partner_id;
  //   if (isCustomerUser) {
  //     finalURL = finalURL + '/customer/' + customer_name + '/available-apps?fetch-images=true';
  //   } else {
  //     finalURL = finalURL + '/apps?enabled=false';
  //   }
  //   this.getRequest(finalURL)
  //     .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
  //       next: (response: any) => {
  //         if (response && response.status === 200) {
  //           this.availApps.next(response.body);
  //         }
  //       }
  //     });
  // }

  goEnabledAppDetails(app: any) {
    const user = this.accountService.getUser();
    let isCustomerUser = false;
    if (user.customer_name) {
      isCustomerUser = true;
    } else {
      isCustomerUser = false;
    }

    if (!isCustomerUser) { // partner scenario
      if (!app.enable_state || (app.enable_state && this.sharedService.isPartnerEnabledAppsAllowedToDetilsPage(app))) {
        this.navigateToAppDetails(user, app);
      }
    } else if (isCustomerUser) { // custpomer scenario
      if (!app.enable_state || (app.enable_state && this.sharedService.isCustomerEnabledAppsAllowedToDetilsPage(app))) {
        this.navigateToAppDetails(user, app);
      }
    }
  }

  goAvailAppDetails(app: any) {
    const user = this.accountService.getUser();
    if (user) {
      this.navigateToAppDetails(user, app);
    } else {
      const link = [`dashboard/app/${app.app_id}`];
      this.router.navigate(link);
    }
  }

  goSpotlightAppDetails(app: any) {
    const user = this.accountService.getUser();
    if (user && app.enable_state) {
      this.goEnabledAppDetails(app);
    } else {
      this.goAvailAppDetails(app);
    }
  }

  navigateToAppDetails(user: any, app: any) {
    const link = [`${user.short_name}/app/${app.app_id}`];
    this.router.navigate(link);
  }

  // getAppDetails(app_Id: any) {
  //   this.getRequest(MNGUrls + '/' + app_Id)
  //     .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
  //       next: (response: any) => {
  //         if (response && response.status === 200) {
  //           this.appDetailsSubject.next(response.body);
  //         }
  //       },
  //       error: (err: any) => {
  //       }
  //     });
  // }


  getAppTiersDomain(app_id: string) {
    const url = MNGUrls.vendorAppBase + '/' + app_id + '/tiers?tier-level=DOMAIN';
    this.getRequest(url)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.tiersArrDomainDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.tiersArrDomainDataSub.next(null);
        }
      });
  }

  getAppTiers(app_id: string) {
    const url = MNGUrls.vendorAppBase + '/' + app_id + '/tiers?tier-level=USER';
    this.getRequest(url)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.tiersArrDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.tiersArrDataSub.next(null);
        }
      });
  }

  getUsersAndConfigDataForPartner(app_id: string, user: PartnerDataModel, partner_id: string) {
    this.spinner.show();
    let getCustomerUsersUrl = APIUrls.partnerApps + user.partner_id + '/customers';
    const responseA = this.getDataForkJoinWithToken(getCustomerUsersUrl);
    let getCustomerUserConfigsUrl = APIUrls.partnerApps + user.partner_id + '/app/' + app_id + '/customer/all/user-config/configs';
    const responseB = this.getDataForkJoinWithToken(getCustomerUserConfigsUrl);
    let getWebhooksDataUrl = APIUrls.generalApps + app_id + '/partner/' + partner_id + '/workflow-definitions';
    const responseC = this.getDataForkJoinWithToken(getWebhooksDataUrl);
    forkJoin([responseA, responseB, responseC])
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
        this.spinner.hide();
        if (forkResponse && forkResponse.length) {
          if (forkResponse[0] && forkResponse[0].status === 200 && forkResponse[0].body
            && forkResponse[1] && forkResponse[1].status === 200 && forkResponse[1].body) {
            this.customerUsersAndConfigForPartnerDataSub.next(forkResponse);
          }
        }
      }, (error) => {
        this.spinner.hide();
      });
  }

  getConfigDataForPartner(app_id: string, user: PartnerDataModel, partner_id: string) {
    let getCustomerUserConfigsUrl = APIUrls.partnerApps + user.partner_id + '/app/' + app_id + '/customer/all/user-config/configs';
    this.getRequest(getCustomerUserConfigsUrl)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.customerConfigForPartnerDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.customerConfigForPartnerDataSub.next(null);
        }
      });
  }

  enableDisableUsersForPartner(customerEnabledUsersForPartner: Array<CustomerEnabledUsersForPartnerDataModel>, user: PartnerDataModel, appDetailsData: AppDataModel,
    customerEnabledUsersForPartnerOrg: Array<CustomerEnabledUsersForPartnerDataModel>) {

    const enabledDomains: any = [];
    const enabledDomainsNew: any = [];
    const enabaledDomainsWithTiers: any = [];
    const enabaledDomainsWithTiersNew: any = [];
    const disabledDomains: any = [];
    // console.log('customerEnabledUsersForPartnerOrg', customerEnabledUsersForPartnerOrg);
    // console.log('customerEnabledUsersForPartner before', customerEnabledUsersForPartner);
    if (customerEnabledUsersForPartner && customerEnabledUsersForPartner.length) {
      customerEnabledUsersForPartner = customerEnabledUsersForPartner.filter(userNew => {
        return (!customerEnabledUsersForPartnerOrg.find((userOrg => {
          if (appDetailsData.domain_mgmt_enabled && appDetailsData.domain_tiers_enabled) {
            return ((userNew.domain === userOrg.domain) && (userNew.config_value === userOrg.config_value)) ||
              ((userNew.config_value === 'Disabled') && userNew.isNew);
          } else if (appDetailsData.domain_mgmt_enabled && !appDetailsData.domain_tiers_enabled) {
            return ((userNew.domain === userOrg.domain) && (userNew.status === userOrg.status)) ||
              ((userNew.status === false) && userNew.isNew)
          }
          return;
        })))
          && !(appDetailsData.domain_mgmt_enabled && appDetailsData.domain_tiers_enabled && (userNew.config_value === 'Disabled') && userNew.isNew)
          && !(appDetailsData.domain_mgmt_enabled && !appDetailsData.domain_tiers_enabled && (userNew.status === false) && userNew.isNew)
      });
    }
    // console.log('customerEnabledUsersForPartner', customerEnabledUsersForPartner);

    if (customerEnabledUsersForPartner.length) {
      if (appDetailsData.domain_mgmt_enabled && appDetailsData.domain_tiers_enabled) {
        // remove existing

        customerEnabledUsersForPartner.forEach(item => {
          if (item.config_value !== 'Disabled') {
            const tempObj = {
              customer_name: item.domain,
              tier_name: item.config_value
            }
            if (item.isNew) {
              enabaledDomainsWithTiersNew.push(tempObj);
            } else {
              enabaledDomainsWithTiers.push(tempObj);
            }
          } else {
            const tempObj = {
              customer_name: item.domain
            }
            disabledDomains.push(tempObj);
          }
        });

      } else if (appDetailsData.domain_mgmt_enabled && !appDetailsData.domain_tiers_enabled) {
        customerEnabledUsersForPartner.forEach(item => {
          if (item.status) {
            const tempObj = {
              customer_name: item.domain,
              enabled: item.status
            }
            if (item.isNew) {
              enabledDomainsNew.push(tempObj);
            } else {
              enabledDomains.push(tempObj);
            }
          } else {
            const tempObj = {
              customer_name: item.domain
            }
            disabledDomains.push(tempObj);
          }
        });

      }
      // console.log('enabledDomains', enabledDomains);
      // console.log('enabledDomains new', enabledDomainsNew);
      // console.log('enabaledDomainsWithTiers', enabaledDomainsWithTiers);
      // console.log('enabaledDomainsWithTiers new', enabaledDomainsWithTiersNew);
      // console.log('disabledDomains', disabledDomains);

      const enableDisableWithManageURL = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id + '/customers';
      // const forkArray = [];
      const forkJoinObj: any = {};
      const reqA = this.putDataForkJoinWithToken(enabledDomains, enableDisableWithManageURL + '?config-action=update');
      const reqB = this.putDataForkJoinWithToken(enabledDomainsNew, enableDisableWithManageURL + '?config-action=create');
      const reqC = this.putDataForkJoinWithToken(enabaledDomainsWithTiers, enableDisableWithManageURL + '?config-action=update');
      const reqD = this.putDataForkJoinWithToken(enabaledDomainsWithTiersNew, enableDisableWithManageURL + '?config-action=create');
      const reqE = this.deleteRequestForkJoinWithTokenA(disabledDomains, enableDisableWithManageURL);

      if (enabledDomains.length) {
        // forkArray.push(reqA);
        forkJoinObj.updateDomains = reqA;
      }
      if (enabledDomainsNew.length) {
        // forkArray.push(reqB);
        forkJoinObj.createNewDomains = reqB;
      }
      if (enabaledDomainsWithTiers.length) {
        // forkArray.push(reqC);
        forkJoinObj.updateDomainsWithTiers = reqC;
      }
      if (enabaledDomainsWithTiersNew.length) {
        // forkArray.push(reqD);
        forkJoinObj.createNewDomainsWithTiers = reqD;
      }
      if (disabledDomains.length) {
        // forkArray.push(reqE);
        forkJoinObj.disableDomains = reqE;
      }

      this.spinner.show();
      forkJoin(forkJoinObj)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
          this.spinner.hide();
          if (forkResponse && Object.keys(forkResponse).length) {
            this.updateDomainsDataSub.next(forkResponse);
          }
        }, (error) => {
          this.spinner.hide();
        });
    } else {
      const obj = {
        alertType: 'openSwal',
        icon: AlertTypes.info,
        text: errorMsgsPopup.noChanges
      }
      this.alertService.alertSubject.next(obj);
    }
  }

  enableUsersForPartnerAtWebhooksDefUpdate(customerEnabledUsersForPartner: Array<CustomerEnabledUsersForPartnerDataModel>, user: PartnerDataModel, appDetailsData: AppDataModel,
    customerEnabledUsersForPartnerOrg: Array<CustomerEnabledUsersForPartnerDataModel>) {

    const enabledDomains: any = [];
    const enabaledDomainsWithTiers: any = [];

    const enableDisableWithManageURL = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id + '/customers';
    // const forkArray = [];
    const forkJoinObj: any = {};
    const reqA = this.putDataForkJoinWithToken(enabledDomains, enableDisableWithManageURL + '?config-action=update');
    const reqB = this.putDataForkJoinWithToken(enabaledDomainsWithTiers, enableDisableWithManageURL + '?config-action=update');

    if (appDetailsData.domain_mgmt_enabled && appDetailsData.domain_tiers_enabled) {
      const tempObj = {
        customer_name: customerEnabledUsersForPartner[0].domain,
        tier_name: customerEnabledUsersForPartner[0].config_value
      }
      enabaledDomainsWithTiers.push(tempObj);
    } else if (appDetailsData.domain_mgmt_enabled && !appDetailsData.domain_tiers_enabled) {
      const tempObj = {
        customer_name: customerEnabledUsersForPartner[0].domain,
        enabled: customerEnabledUsersForPartner[0].status
      }
      enabledDomains.push(tempObj);
    }

    if (enabledDomains.length) {
      forkJoinObj.updateDomains = reqA;
    }
    if (enabaledDomainsWithTiers.length) {
      forkJoinObj.updateDomainsWithTiers = reqB;
    }

    this.spinner.show();
    forkJoin(forkJoinObj)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
        this.spinner.hide();
        if (forkResponse && Object.keys(forkResponse).length) {
          this.updateDomainsAtWebhooksDefUpdateDataSub.next(forkResponse);
        }
      }, (error) => {
        this.spinner.hide();
      });
  }

  disableUsersForPartnerAtWebhooksDefUpdate(customerEnabledUsersForPartner: Array<CustomerEnabledUsersForPartnerDataModel>, user: PartnerDataModel, appDetailsData: AppDataModel,
    customerEnabledUsersForPartnerOrg: Array<CustomerEnabledUsersForPartnerDataModel>) {

    const disabledDomains: any = [];

    const tempObj = {
      customer_name: customerEnabledUsersForPartner[0].domain
    }
    disabledDomains.push(tempObj);

    const enableDisableWithManageURL = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id + '/customers';

    const reqA = this.deleteRequestForkJoinWithTokenA(disabledDomains, enableDisableWithManageURL);

    const forkJoinObj: any = {};
    if (disabledDomains.length) {
      forkJoinObj.disabledDomains = reqA;
    }
    this.spinner.show();
    forkJoin(forkJoinObj)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
        this.spinner.hide();
        if (forkResponse && Object.keys(forkResponse).length) {
          this.disableDomainsAtWebhooksDefUpdateDataSub.next(forkResponse);
        }
      }, (error) => {
        this.spinner.hide();
      });
  }

  getUsersAndConfigData(app_id: string, user: PartnerDataModel, partner_id: string) {
    this.spinner.show();
    let getCustomerUsersUrl = APIUrls.partnerApps + user.partner_id + '/customer/' +
      user.customer_name + '/users';
    const responseA = this.getDataForkJoinWithToken(getCustomerUsersUrl);
    let getCustomerUserConfigsUrl = APIUrls.partnerApps + user.partner_id + '/app/' + app_id + '/customer/' +
      user.customer_name + '/user-config/configs';
    const responseB = this.getDataForkJoinWithToken(getCustomerUserConfigsUrl);
    let getWebhooksDataUrl = APIUrls.generalApps + app_id + '/partner/' + partner_id + '/customer/' + user.customer_name + '/workflow-definitions';
    const responseC = this.getDataForkJoinWithToken(getWebhooksDataUrl);

    forkJoin([responseA, responseB, responseC])
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
        this.spinner.hide();
        if (forkResponse && forkResponse.length) {
          if (forkResponse[0] && forkResponse[0].status === 200 && forkResponse[0].body
            && forkResponse[1] && forkResponse[1].status === 200 && forkResponse[1].body) {
            this.customerUsersAndConfigDataSub.next(forkResponse);
          }
        }
      });
  }

  getConfigData(app_id: string, user: PartnerDataModel, partner_id: string) {
    let getCustomerUserConfigsUrl = APIUrls.partnerApps + user.partner_id + '/app/' + app_id + '/customer/' +
      user.customer_name + '/user-config/configs';
    this.getRequest(getCustomerUserConfigsUrl)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.customerConfigDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.customerConfigDataSub.next(null);
        }
      });
  }

  enableDisableUsers(customerEnabledUsers: Array<CustomerEnabledUsersDataModel>, user: PartnerDataModel, appDetailsData: AppDataModel,
    customerEnabledUsersOrg: Array<CustomerEnabledUsersDataModel>
  ) {
    const enabledUsers: any = [];
    const enabledUsersNew: any = [];
    const enabaledUsersWithTiers: any = [];
    const enabaledUsersWithTiersNew: any = [];
    const disabledUsers: any = [];
    if (customerEnabledUsers && customerEnabledUsers.length) {
      customerEnabledUsers = customerEnabledUsers.filter(userNew => {
        return (!customerEnabledUsersOrg.find((userOrg => {
          if (appDetailsData.user_mgmt_enabled && appDetailsData.user_tiers_enabled) {
            return ((userNew.domain === userOrg.domain) && (userNew.config_value === userOrg.config_value)
              && (userNew.user === userOrg.user) && (userNew.scope === userOrg.scope))
              || ((userNew.config_value === 'Disabled') && userNew.isNew);
          } else if (appDetailsData.user_mgmt_enabled && !appDetailsData.user_tiers_enabled) {
            return ((userNew.domain === userOrg.domain) && (userNew.status === userOrg.status)
              && (userNew.user === userOrg.user) && (userNew.scope === userOrg.scope))
              || ((userNew.status === false) && userNew.isNew);
          }
          return;
        })))
          && !(appDetailsData.user_mgmt_enabled && appDetailsData.user_tiers_enabled && (userNew.config_value === 'Disabled') && userNew.isNew)
          && !(appDetailsData.user_mgmt_enabled && !appDetailsData.user_tiers_enabled && (userNew.status === false) && userNew.isNew)
      });
    }
    // console.log('customerEnabledUsersOrg', customerEnabledUsersOrg);
    // console.log('customerEnabledUsers', customerEnabledUsers);
    if (customerEnabledUsers.length) {
      if (appDetailsData.user_mgmt_enabled && appDetailsData.user_tiers_enabled) {
        customerEnabledUsers.forEach(item => {
          if (item.config_value !== 'Disabled') {
            const tempObj = {
              user_id: item.user,
              tier_name: item.config_value
            }
            if (item.isNew) {
              enabaledUsersWithTiersNew.push(tempObj);
            } else {
              enabaledUsersWithTiers.push(tempObj);
            }
          } else {
            const tempObj = {
              user_id: item.user
            }
            disabledUsers.push(tempObj);
          }
        });

      } else if (appDetailsData.user_mgmt_enabled && !appDetailsData.user_tiers_enabled) {

        customerEnabledUsers.forEach(item => {
          if (item.status) {
            const tempObj = {
              user_id: item.user,
              enabled: item.status
            }
            if (item.isNew) {
              enabledUsersNew.push(tempObj);
            } else {
              enabledUsers.push(tempObj);
            }

          } else {
            const tempObj = {
              user_id: item.user
            }
            disabledUsers.push(tempObj);
          }
        });

      }
      // console.log('enabledUsers', enabledUsers);
      // console.log('enabledUsers new', enabledUsersNew);
      // console.log('enabaledUsersWithTiers', enabaledUsersWithTiers);
      // console.log('enabaledUsersWithTiers new', enabaledUsersWithTiersNew);
      // console.log('disabledUsers', disabledUsers);

      const enableDisableWithManageURL = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id + '/customer/'
        + user.customer_name + '/users';

      // const forkArray = [];
      const forkJoinObj: any = {};
      const reqA = this.putDataForkJoinWithToken(enabledUsers, enableDisableWithManageURL + '?config-action=update');
      const reqB = this.putDataForkJoinWithToken(enabledUsersNew, enableDisableWithManageURL + '?config-action=create');
      const reqC = this.putDataForkJoinWithToken(enabaledUsersWithTiers, enableDisableWithManageURL + '?config-action=update');
      const reqD = this.putDataForkJoinWithToken(enabaledUsersWithTiersNew, enableDisableWithManageURL + '?config-action=create');
      const reqE = this.deleteRequestForkJoinWithTokenA(disabledUsers, enableDisableWithManageURL);

      if (enabledUsers.length) {
        // forkArray.push(reqA);
        forkJoinObj.updateUsers = reqA;
      }
      if (enabledUsersNew.length) {
        // forkArray.push(reqB);
        forkJoinObj.createNewUsers = reqB;
      }
      if (enabaledUsersWithTiers.length) {
        // forkArray.push(reqC);
        forkJoinObj.updateUsersWithTiers = reqC;
      }
      if (enabaledUsersWithTiersNew.length) {
        // forkArray.push(reqD);
        forkJoinObj.createNewUsersWithTiers = reqD;
      }
      if (disabledUsers.length) {
        // forkArray.push(reqE);
        forkJoinObj.disableUsers = reqE;
      }
      // let requestA: any = '';
      // if (appDetailsData.user_mgmt_enabled && appDetailsData.user_tiers_enabled) {
      //   requestA = this.putDataForkJoinWithToken(enabaledUsersWithTiers, enableDisableWithManageURL);
      // } else if (appDetailsData.user_mgmt_enabled && !appDetailsData.user_tiers_enabled) {
      //   requestA = this.putDataForkJoinWithToken(enabledUsers, enableDisableWithManageURL);
      // }

      // const requestB = this.deleteRequestForkJoinWithTokenA(disabledUsers, enableDisableWithManageURL);

      // const forkArray = [];
      // if ((enabaledUsersWithTiers && enabaledUsersWithTiers.length) || (enabledUsers && enabledUsers.length)) {
      //   forkArray.push(requestA);
      // }
      // if (disabledUsers && disabledUsers.length) {
      //   forkArray.push(requestB);
      // }
      this.spinner.show();
      forkJoin(forkJoinObj)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
          this.spinner.hide();
          if (forkResponse && Object.keys(forkResponse).length) {
            this.updateUsersDataSub.next(forkResponse);
          }
          // if (forkResponse && forkResponse.length) {
          //   this.spinner.hide();
          //   this.updateUsersDataSub.next(true);
          // }
        }, (error) => {
          this.spinner.hide();
        });
    } else {
      const obj = {
        alertType: 'openSwal',
        icon: AlertTypes.info,
        text: errorMsgsPopup.noChanges
      }
      this.alertService.alertSubject.next(obj);
    }
  }

  enableUsersAtWebhooksDefUpdate(customerEnabledUsers: Array<CustomerEnabledUsersDataModel>, user: PartnerDataModel, appDetailsData: AppDataModel,
    customerEnabledUsersOrg: Array<CustomerEnabledUsersDataModel>
  ) {
    const enabledUsers: any = [];
    const enabaledUsersWithTiers: any = [];

    if (appDetailsData.user_mgmt_enabled && appDetailsData.user_tiers_enabled) {
      const tempObj = {
        user_id: customerEnabledUsers[0].user,
        tier_name: customerEnabledUsers[0].config_value
      }
      enabaledUsersWithTiers.push(tempObj);
    } else if (appDetailsData.user_mgmt_enabled && !appDetailsData.user_tiers_enabled) {
      const tempObj = {
        user_id: customerEnabledUsers[0].user,
        enabled: customerEnabledUsers[0].status
      }
      enabledUsers.push(tempObj);
    }

    const enableDisableWithManageURL = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id + '/customer/'
      + user.customer_name + '/users';

    // const forkArray = [];
    const forkJoinObj: any = {};
    const reqA = this.putDataForkJoinWithToken(enabledUsers, enableDisableWithManageURL + '?config-action=update');
    const reqB = this.putDataForkJoinWithToken(enabaledUsersWithTiers, enableDisableWithManageURL + '?config-action=update');

    if (enabledUsers.length) {
      forkJoinObj.updateUsers = reqA;
    }
    if (enabaledUsersWithTiers.length) {
      forkJoinObj.updateUsersWithTiers = reqB;
    }

    this.spinner.show();
    forkJoin(forkJoinObj)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
        this.spinner.hide();
        if (forkResponse && Object.keys(forkResponse).length) {
          this.updateUsersAtWebhooksDefUpdateDataSub.next(forkResponse);
        }
      }, (error) => {
        this.spinner.hide();
      });
  }

  disableUsersAtWebhooksDefUpdate(customerEnabledUsers: Array<CustomerEnabledUsersDataModel>, user: PartnerDataModel, appDetailsData: AppDataModel,
    customerEnabledUsersOrg: Array<CustomerEnabledUsersDataModel>) {

    const disabledUsers: any = [];

    const tempObj = {
      user_id: customerEnabledUsers[0].user
    }
    disabledUsers.push(tempObj);

    const enableDisableWithManageURL = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id + '/customer/'
      + user.customer_name + '/users';
    const reqA = this.deleteRequestForkJoinWithTokenA(disabledUsers, enableDisableWithManageURL);

    const forkJoinObj: any = {};
    if (disabledUsers.length) {
      forkJoinObj.disabledUsers = reqA;
    }
    this.spinner.show();
    forkJoin(forkJoinObj)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
        this.spinner.hide();
        if (forkResponse && Object.keys(forkResponse).length) {
          this.disableUsersAtWebhooksDefUpdateDataSub.next(forkResponse);
        }
      }, (error) => {
        this.spinner.hide();
      });
  }

  getPartnerAppsApiBaseUrl(user: PartnerDataModel, appDetailsData: AppDataModel) {
    return APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id;
  }

  async publishApp(isCustomerUser: boolean, appDetailsData: AppDataModel, user: PartnerDataModel) {
    const requestUrl = this.getPartnerAppsApiBaseUrl(user, appDetailsData) + '/state';
    const reqObj = {
      "enable_state": "AVAILABLE"
    }
    try {
      return await lastValueFrom(
        this.patchRequest(reqObj, requestUrl)
      )
    }
    catch (e) {
      return null;
    }
  }

  requestAccessForApp(isCustomerUser: boolean, appDetailsData: AppDataModel, user: PartnerDataModel,
    defaultTierValue?: string) {
    if (isCustomerUser) {
      const finalURL = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id +
        '/customer/' + user.customer_name;
      let reqObj: any = '';
      if (defaultTierValue) {
        reqObj = {
          customer_name: user.customer_name,
          tier_name: defaultTierValue
        }
      }
      this.putRequest(reqObj ? [reqObj] : '', finalURL)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
          next: (response: any) => {
            if (response && response.status === 200) {
              if (appDetailsData.approval_flow_enabled) {
                this.accountService.goHome();
              } else if (!appDetailsData.approval_flow_enabled)
                this.requestAccessForAppDataSub.next(true);
            }
          }
        });
    } else {
      this.spinner.show();
      let forKJoinArr = [];
      let response: any = '';
      let reqObj: any;
      const finalURL = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id;
      if (appDetailsData.approval_flow_enabled && appDetailsData.approval_flow_email) {
        const tempArr = appDetailsData.approval_flow_email.match(/[^,\s]+/g);
        reqObj = {
          approval_flow_enabled: appDetailsData.approval_flow_enabled,
          approval_flow_emails: tempArr
        }
        // response = this.putDataForkJoinWithToken(reqObj, finalURL);
      } else {
        reqObj = {
          approval_flow_enabled: false,
          approval_flow_emails: []
        }
        // response = this.putDataForkJoinWithToken('', finalURL);
      }
      response = this.putDataForkJoinWithToken(reqObj, finalURL);
      forKJoinArr.push(response);
      forkJoin(forKJoinArr)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
          if (forkResponse && forkResponse.length) {
            this.spinner.hide();
            this.requestAccessForAppDataSubA.next(true);
          }
        }, (error) => {
          this.spinner.hide();
          // const obj = {
          //   alertType: 'openSwal',
          //   icon: AlertTypes.error,
          //   text: errorMsgsPopup.somethingWentWrong
          // }
          // this.alertService.alertSubject.next(obj);
        });
    }
  }

  async checkRevokeState(isCustomerUser: boolean, appDetailsData: AppDataModel, user: PartnerDataModel, isFromStoreLanding = false) {
    if (isCustomerUser) {
      // call manage users api
      let reqUrl = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id + '/customer/' +
        user.customer_name + '/user-config/configs';
      try {
        let data: any = '';
        if (appDetailsData.user_mgmt_enabled) {
          data = await lastValueFrom(
            this.getRequest(reqUrl)
          )
        }

        if (data && data.body && data.body.length) {
          const text = errorMsgsPopup.revokeCheckOmHeading;
          this.alertService.alertConfirmCommon('', text, AlertTypes.question, '', '', true).then((result => {
            if (result.isConfirmed) {
              setTimeout(() => {
                this.revokeStateDataSubOM.next(data.body);
              }, 200);
            }
          }))
        } else {
          const alertText = 'Disable app ' + appDetailsData.app_name + ' for ' + appDetailsData?.customer_name + '.';
          this.alertService.alertConfirmCommon(AlertTitles.areYouSureTitle, alertText, AlertTypes.question,
            '', '', true).then((result) => {
              if (result.isConfirmed) {
                this.disableApp(isCustomerUser, appDetailsData, user, isFromStoreLanding);
              }
            });
        }
      }
      catch (e) {
        // console.log(e);
      }
    } else {
      // call approvals api with app Id
      const reqUrl = APIUrls.partnerApps + user.partner_id + '/customer-app/apps?app-id=' + appDetailsData.app_id;
      try {
        const data = await lastValueFrom(
          this.getRequest(reqUrl)
        )
        if (data && data.body && data.body.length) {
          const text = errorMsgsPopup.revokeCheckSuHeading;
          this.alertService.alertConfirmCommon('', text, AlertTypes.question, '', '', true).then((result => {
            if (result.isConfirmed) {
              setTimeout(() => {
                this.revokeStateDataSub.next(data.body);
              }, 200);
            }
          }))
        } else {
          const alertText = 'Disable app ' + appDetailsData.app_name + '.';
          this.alertService.alertConfirmCommon(AlertTitles.areYouSureTitle, alertText, AlertTypes.question,
            '', '', true).then((result) => {
              if (result.isConfirmed) {
                this.disableApp(isCustomerUser, appDetailsData, user, isFromStoreLanding);
              }
            });
        }
      }
      catch (e) {
        // console.log(e);
      }
    }
  }

  disableApp(isCustomerUser: boolean, appDetailsData: AppDataModel, user: PartnerDataModel, isFromStoreLanding = false) {
    if (isCustomerUser) {
      const finalURL = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id
        + '/customer/' + user.customer_name;
      this.deleteRequestA('', finalURL)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
          next: (response: any) => {
            if (response && response.status === 200) {
              if (isFromStoreLanding) {
                // this.getEnabledApps(isCustomerUser, user.partner_id, user.customer_name);
                // this.getAvailApps(isCustomerUser, user.partner_id, user.customer_name);
                this.getDifferentAppLists(isCustomerUser, user.partner_id, user.customer_name,
                  true, null,
                  true, null,
                  true, null,
                  false, null);
              } else {
                this.accountService.goHome();
              }
            }
          }
        });
    } else {
      this.spinner.show();
      let forKJoinArr = [];
      const finalURL = APIUrls.partnerApps + user.partner_id + '/app/' + appDetailsData.app_id;
      const response = this.deleteRequestForkJoinWithToken(finalURL);
      forKJoinArr.push(response);
      forkJoin(forKJoinArr)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
          if (forkResponse && forkResponse.length) {
            this.spinner.hide();
            if (isFromStoreLanding) {
              // this.getEnabledApps(isCustomerUser, user.partner_id, user.customer_name);
              // this.getAvailApps(isCustomerUser, user.partner_id, user.customer_name);
              this.getDifferentAppLists(isCustomerUser, user.partner_id, user.customer_name,
                true, null,
                true, null,
                true, null,
                false, null);
            } else {
              this.accountService.goHome();
            }
          }
        }, (error) => {
          this.spinner.hide();
        });
    }

  }

  customizeApp(createAppDataModel: CreateAppDataModel, appDetailsData: AppDataModel, partner_id: string) {
    // console.log(createAppDataModel, partner_id);
    if (!createAppDataModel.app_name && !createAppDataModel.short_description && (!createAppDataModel.description || createAppDataModel.description === '<br>')) {
      const obj = {
        alertType: 'openSwal',
        icon: AlertTypes.error,
        text: errorMsgsPopup.selectLeastOneField
      }
      this.alertService.alertSubject.next(obj);
    } else {
      const reqObj = {
        app_name: createAppDataModel.app_name ? createAppDataModel.app_name : null,
        short_description: createAppDataModel.short_description ? createAppDataModel.short_description : null,
        description: createAppDataModel.description ? createAppDataModel.description : null
      }
      this.putRequest(reqObj, APIUrls.partnerApps + partner_id + '/app/' + appDetailsData.app_id)
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
          next: (response: any) => {
            if (response && response.status === 200) {
              this.customizeAppDataSub.next(response.body);
            }
          }
        });
    }
  }

  // getCuztomizedAppDocs(app_id: any, partner_id: string) {
  //   const url = APIUrls.generalApps + app_id + '/partner/' + partner_id + '/app-documents?upload-status=COMPLETE&fallback-to-original=false';
  //   this.getRequest(url)
  //     .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
  //       next: (response: any) => {
  //         if (response && response.status === 200) {
  //           this.appCustomizeAppDocsDataSub.next(response.body);
  //         }
  //       },
  //       error: (err: any) => {
  //         this.appCustomizeAppDocsDataSub.next(null);
  //       }
  //     });
  // }

  getCustomizeAppImageUploadUrls(app_id: any, partner_id: string) {
    const url = APIUrls.partnerApps + partner_id + '/app/' + app_id + '/image-urls';
    this.getRequest(url)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.customizeAppImageUrlsDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.customizeAppImageUrlsDataSub.next(null);
        }
      });
  }

  createCustomizeAppImg(createAppDataModel: CreateAppDataModel) {
    if (createAppDataModel.app_icon_file && createAppDataModel.app_image_file) {
      this.spinner.show();
      const response = this.putDataForkJoinSkipIntercept(createAppDataModel.app_icon_file, createAppDataModel.app_icon_upload_url);
      const responseA = this.putDataForkJoinSkipIntercept(createAppDataModel.app_image_file, createAppDataModel.app_image_upload_url);

      forkJoin([response, responseA])
        .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
          if (forkResponse && forkResponse.length) {
            this.spinner.hide();
            this.uploadImgDataSub.next(true);
          }
        }, (error) => {
          console.log('error at service', error);
          this.spinner.hide();
          const obj = {
            alertType: 'openSwal',
            icon: AlertTypes.error,
            text: errorMsgsPopup.uploadFailed
          }
          this.alertService.alertSubject.next(obj);
        });
    } else if (createAppDataModel.app_icon_file) {
      this.uploadVendorAppImages(createAppDataModel.app_icon_file, createAppDataModel.app_icon_upload_url);
    } else if (createAppDataModel.app_image_file) {
      this.uploadVendorAppImages(createAppDataModel.app_image_file, createAppDataModel.app_image_upload_url);
    } else {

    }
  }

  uploadVendorAppImages(file: any, uploadUrl: any) {
    this.spinner.show();
    const response = this.putDataForkJoinSkipIntercept(file, uploadUrl);
    forkJoin([response])
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
        if (forkResponse && forkResponse.length) {
          this.spinner.hide();
          this.uploadImgDataSub.next(true);
        }
      }, (error) => {
        // console.log('error at service', error);
        this.spinner.hide();
      });
  }

  removeAppCustomization(appDetailsData: AppDataModel, partner_id: string) {
    const alertText = 'Remove customization for app ' + appDetailsData.app_name + '.';
    this.alertService.alertConfirmCommon(AlertTitles.areYouSureTitle, alertText, AlertTypes.question,
      '', '', true).then((result) => {
        if (result.isConfirmed) {
          const removeCustomizationURL = APIUrls.partnerApps + partner_id + '/app/' + appDetailsData.app_id
            + '/customisation';
          this.deleteRequest(removeCustomizationURL)
            .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
              next: (response: any) => {
                if (response && response.status === 200) {
                  this.appInitDataSub.next(true);
                }
              }
            });
        }
      });
  }

  viewOriginalApp(appDetailsData: AppDataModel) {

    // this.spinner.show();
    // let getAppDetailsData = MNGUrls.appBase + '/' + appDetailsData.app_id;
    // const responseA = this.getDataForkJoinSkipIntercept(getAppDetailsData);
    // let getTechDetailsOriginalData = MNGUrls.appBase + '/' + appDetailsData.app_id + '/app-documents?upload-status=COMPLETE';
    // const responseB = this.getDataForkJoinSkipIntercept(getTechDetailsOriginalData);

    // forkJoin([responseA])
    //   .pipe(takeWhile(() => !this.destroySubscription)).subscribe((forkResponse: any) => {
    //     this.spinner.hide();
    //     if (forkResponse && forkResponse.length) {
    //       if (forkResponse[0] && forkResponse[0].status === 200 && forkResponse[0].body
    //         && forkResponse[1] && forkResponse[1].status === 200 && forkResponse[1].body) {
    //         // this.customerUsersAndConfigForPartnerDataSub.next(forkResponse);
    //         const tempObj = {
    //           appData: forkResponse[0].body,
    //           appDocuments: forkResponse[1].body
    //         }
    //         this.viewOriginalAppDataSub.next(tempObj);
    //       }
    //     }
    //   }, (error) => {
    //     this.spinner.hide();
    //   });


    this.getRequest(MNGUrls.vendorAppBase + '/' + appDetailsData.app_id)
      .pipe(takeWhile(() => !this.destroySubscription)).subscribe({
        next: (response: any) => {
          if (response && response.status === 200) {
            this.viewOriginalAppDataSub.next(response.body);
          }
        },
        error: (err: any) => {
          this.viewOriginalAppDataSub.next(null);
        }
      });
  }

  allowedAppState(enable_state: string) {
    const user = this.accountService.getUser();
    if (user && user.customer_name) {
      return enable_state === AppStatesTexts.requested || enable_state === AppStatesTexts.processing
        || enable_state === AppStatesTexts.readytoActivate || enable_state === AppStatesTexts.preEnabled;
    } else {
      return enable_state === AppStatesTexts.requested || enable_state === AppStatesTexts.processing
        || enable_state === AppStatesTexts.readytoPublish;
    }
  }

  allowedAppStateForRevoke(enable_state: string) {
    const user = this.accountService.getUser();
    if (user && user.customer_name) {
      return (!user.restrict_marketplace_access || (user.restrict_marketplace_access && user.masquerading_user_id))
        && (enable_state === AppStatesTexts.requested || enable_state === AppStatesTexts.processing
          || enable_state === AppStatesTexts.readytoActivate || enable_state === AppStatesTexts.enabled
          || enable_state === AppStatesTexts.preEnabled)
    } else {
      return enable_state === AppStatesTexts.requested || enable_state === AppStatesTexts.processing
        || enable_state === AppStatesTexts.readytoPublish || enable_state === AppStatesTexts.available
    }
  }

  getStateContainerClass(enable_state: string) {
    const user = this.accountService.getUser();
    if (user && user.customer_name) {
      return (enable_state === AppStatesTexts.readytoActivate || enable_state === AppStatesTexts.enabled) ? 'ribbon-container-adj' : '';
    } else {
      return (enable_state === AppStatesTexts.readytoPublish || enable_state === AppStatesTexts.available) ? 'ribbon-container-adj' : '';
    }
  }

  enableStateClass(enable_state: string) {
    if (!enable_state) {
      return '';
    }
    let className = '';
    if (enable_state === AppStatesTexts.requested) {
      className = 'bg-info-opac'
    } else if (enable_state === AppStatesTexts.processing) {
      className = 'bg-success-opac'
    } else if (enable_state === AppStatesTexts.readytoPublish ||
      enable_state === AppStatesTexts.readytoActivate) {
      className = 'bg-warning-opac'
    } else if (enable_state === AppStatesTexts.available ||
      enable_state === AppStatesTexts.enabled) {
      className = 'bg-primary-opac'
    } else if (enable_state === AppStatesTexts.preEnabled) {
      className = 'bg-danger-opac'
    }
    return className;
  }

  async sendInfoEmail(app_id: string) {
    const user = this.accountService.getUser();
    const reqUrl = APIUrls.partnerApps + user.partner_id + '/app/' + app_id + '/customer/' + user.customer_name +
      '/' + MNGUrls.requestInfo;
    try {
      const data = await lastValueFrom(
        this.postRequest('', reqUrl)
      );
      if (data && data.ok) {
        const obj = {
          alertType: 'autoClose',
          icon: AlertTypes.success,
          title: AlertTitles.emailSentSuccessFully,
          text: ''
        }
        this.alertService.alertSubject.next(obj);
      }
    }
    catch (e) {
      // return null;
    }
  }

  getRequest(reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.getData(reqUrl + (urlData ? urlData : ''));
  }

  postRequest(reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.postData(reqObj, reqUrl + (urlData ? urlData : ''));
  }

  putRequest(reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.putData(reqObj, reqUrl + (urlData ? urlData : ''));
  }

  patchRequest(reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.patchData(reqObj, reqUrl + (urlData ? urlData : ''));
  }

  putDataForkJoinSkipIntercept(reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.putDataForkJoinSkipIntercept(reqObj, reqUrl + (urlData ? urlData : ''));
  }

  deleteRequest(deleteUrl: string, urlParams?: any, empId?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.deleteRequest(deleteUrl + (urlData ? urlData : ''));
  }

  deleteRequestA(reqObj: any, deleteUrl: string) {
    return this.baseService.deleteRequestA(reqObj, deleteUrl);
  }

  getDataForkJoinWithToken(reqUrl: string) {
    return this.baseService.getDataForkJoinWithToken(reqUrl);
  }

  getDataForkJoinSkipIntercept(reqUrl: string) {
    return this.baseService.getDataForkJoinSkipIntercept(reqUrl);
  }


  postDataForkJoinWithToken(reqObj: any, reqUrl: string) {
    return this.baseService.postDataForkJoinWithToken(reqObj, reqUrl);
  }

  putDataForkJoinWithToken(reqObj: any, reqUrl: string) {
    return this.baseService.putDataForkJoinWithToken(reqObj, reqUrl);
  }

  deleteRequestForkJoinWithToken(reqUrl: string) {
    return this.baseService.deleteRequestForkJoinWithToken(reqUrl);
  }

  deleteRequestForkJoinWithTokenA(reqObj: any, reqUrl: string) {
    return this.baseService.deleteRequestForkJoinWithTokenA(reqObj, reqUrl);
  }
}
